"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import CommonAnimationWrapper from "@/components/utils/animation/CommonAnimationWrapper";
import CommonAnimationOpacity from "@/components/utils/animation/CommonAnimationOpacity";
import HeaderSearchModal from "./HeaderSearchModal";
import { useKey } from "react-use";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
export default function HeaderSearchButton() {
  const $ = _c(22);
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef(null);
  const wasOpenRef = useRef(false);
  const {
    isApp
  } = useDeviceInfo();
  let t0;
  let t1;
  if ($[0] !== isOpen) {
    t0 = () => {
      let rafId = null;
      if (wasOpenRef.current && !isOpen) {
        rafId = window.requestAnimationFrame(() => {
          buttonRef.current?.focus({
            preventScroll: true
          });
        });
      }
      wasOpenRef.current = isOpen;
      return () => {
        if (rafId !== null) {
          window.cancelAnimationFrame(rafId);
        }
      };
    };
    t1 = [isOpen];
    $[0] = isOpen;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsOpen(true);
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleOpen = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsOpen(false);
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleClose = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      event: "keydown"
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  useKey(_temp, handleOpen, t4);
  const iconSizeClasses = isApp ? "tw-h-6 tw-w-6" : "tw-h-5 tw-w-5";
  const t5 = isApp ? "tw-bg-black" : "tw-bg-iron-800 tw-ring-1 tw-ring-inset tw-ring-iron-700 hover:tw-bg-iron-700";
  let t6;
  if ($[6] !== t5) {
    t6 = clsx("tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-h-10 tw-w-10 tw-border-0 tw-text-iron-300 hover:tw-text-iron-50 tw-shadow-sm focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-primary-400 tw-transition tw-duration-300 tw-ease-out", t5);
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== iconSizeClasses) {
    t7 = clsx("tw-flex-shrink-0", iconSizeClasses);
    $[8] = iconSizeClasses;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t7) {
    t8 = <MagnifyingGlassIcon className={t7} />;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t6 || $[13] !== t8) {
    t9 = <button ref={buttonRef} type="button" aria-label="Search" title="Search" onClick={handleOpen} className={t6}>{t8}</button>;
    $[12] = t6;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== isOpen) {
    t10 = isOpen && <CommonAnimationOpacity key="modal" elementClasses="tw-absolute tw-z-10" elementRole="dialog" onClicked={_temp2}><HeaderSearchModal onClose={handleClose} /></CommonAnimationOpacity>;
    $[15] = isOpen;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10) {
    t11 = <CommonAnimationWrapper mode="sync" initial={true}>{t10}</CommonAnimationWrapper>;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t9) {
    t12 = <div className="tailwind-scope tw-self-center">{t9}{t11}</div>;
    $[19] = t11;
    $[20] = t9;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  return t12;
}
function _temp2(e) {
  return e.stopPropagation();
}
function _temp(event) {
  return event.metaKey && event.key === "k";
}